import { BaseError } from '@hsp/utilities';

import { s } from 'utilities/strings';

export class TokenMissingError extends BaseError {
  constructor() {
    super(s('Api.Token.Missing'));
  }
}
